import React, { useState } from "react";
import Collapse from "@material-ui/core/Collapse";
import ListItem from "@material-ui/core/ListItem";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/styles";
import styleConstants from "../../styleConstants";

const styles = {
  heading: {
    fontSize: "0.875rem",
    fontWeight: styleConstants.fontWeights.medium
  },
  content: {
    fontSize: "0.875rem"
  }
};

const CountryGroupsItem = props => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <>
      <ListItem onClick={handleClick}>
        <div className={props.classes.heading}>{props.heading}</div>
        {/* <ListItemText className={props.classes.heading} primary={props.heading} /> */}
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <ListItem>
          <div
            className={props.classes.content}
            dangerouslySetInnerHTML={{ __html: props.countries }}
          />
        </ListItem>
      </Collapse>
    </>
  );
};

export default withStyles(styles)(CountryGroupsItem);
